import React from "react";

import RoundButton, { RoundButtonProps } from "@app/component/RoundButton";

interface ActionButtonProps extends RoundButtonProps {
  invisible?: boolean;
}

// filtering out invisible prop added by ListWithOverflowItems to avoid leaking it to the
// DOM and causing a console warning
const ActionButton = ({ invisible, ...props }: ActionButtonProps) => {
  return <RoundButton {...props} />;
};

export default ActionButton;
